import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import compose from 'ramda/es/compose';
import { createStructuredSelector } from 'reselect';
import { Modal } from './modal.component';
import {
  selectModalContent,
  selectIsModalOpen,
} from '../../reducers/accessories/accessories.selectors';

import { AccessoryActions } from '../../reducers/accessories/accessories.redux';


const mapStateToProps = createStructuredSelector({
  contentEntry: selectModalContent,
  isOpen: selectIsModalOpen,
});

const mapDispatchToProps = (dispatch) => bindActionCreators({
  closeModal: AccessoryActions.closeModal,
}, dispatch);

export default compose(connect(mapStateToProps, mapDispatchToProps))(Modal);
